import React from "react";

export default function Hero() {
  return (
    <section className="rf-hero" id="top" data-testid="hero">
      <picture className="rf-hero__media">
        <source media="(max-width: 1023px)" srcSet="/assets/m-hero.png" />
        <img src="/assets/d-hero.png" alt="" aria-hidden="true" />
      </picture>
      <div className="rf-hero__body">
        <div className="rf-wrap">
          <div className="rf-hero__copy">
            <h1 className="rf-h1">
              Modern Construction.
              <br />
              Well Done!
            </h1>
            <a href="#applications" className="rf-btn rf-btn--green rf-btn--hero" data-testid="hero-cta">
              EXPLORE APPLICATIONS
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
